import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'  
import 'vue-croppa/dist/vue-croppa.css' 
import Croppa from 'vue-croppa';   
import './config'; 
import $ from 'jquery';    
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; 

Vue.use(ElementUI);

Vue.config.productionTip = false   
Vue.use(Croppa);
 
Vue.use($)
 
Vue.prototype.getNowFormatDate = function() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
};
Vue.prototype.getYesterDate = function() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate()-1;
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
};
Vue.prototype.formatDate = function(date,format) {
   /*
  * eg:format="Y-MM-dd hh:mm:ss";
  */
  var o = {
    "M+" : date.month+1, //month
    "d+" :date.date,  //day
    "h+" : date.hours,   //hour
    "m+" : date.minutes, //minute
    "s+" :date.seconds, //second
    "q+" : Math.floor((date.month+3)/3), //quarter
    "S" : date.milliseconds, //millisecond
    "Y":date.year+1900 
   }
   
   if(/(y+)/.test(format)) {
   format = format.replace(RegExp.$1, (Y+"").substr(4 - RegExp.$1.length));
   }
   
   for(var k in o) {
   if(new RegExp("("+ k +")").test(format)) {
    format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
   }
   }
  return format;
};
new Vue({
  router,
  store, 
  render: h => h(App),
}).$mount('#app')
